"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var _default = () => window.innerWidth < parseInt(_constants.breakpoints.smallDesktop, 10);

exports.default = _default;